import Globalize from './globalize';
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';

export type MessagesDefinition = {
  [languageCode: string]: Object,
};

const joinMessages = (lngMessages: Array<MessagesDefinition>): MessagesDefinition =>
  Object.assign({}, ...lngMessages);
const normalizeMessages = (messages: Array<MessagesDefinition> | MessagesDefinition): MessagesDefinition =>
  (Array.isArray(messages)) ? joinMessages(messages) : messages;

let initializePromise = null;

/**
 * Inicializuje Globalize a vraci pole dostupnych jazyku pro UI.
 *
 * @function initializeGlobalize
 * @param defaultLanguage Prednastaveny jazuk aplikace.
 * @param messages Preklady textu aplikace.
 * @returns Pole kodu dostupnych jazyku pro UI.
 */
function initializeGlobalize(
  defaultLanguage: string,
  availableLanguages: Array<string>,
  messages: Array<MessagesDefinition> | MessagesDefinition
): Promise<void> {

  if(initializePromise === null){ 
    defaultLanguage = defaultLanguage || 'en';
    availableLanguages = availableLanguages || ['en'];
    initializePromise =  Promise.all(compact([
      import(/* webpackChunkName: "cldr-supplemental" */ './cldr/supplemental'),
      defaultLanguage === 'cs' ? import(/* webpackChunkName: "cldr-cs" */ './cldr/cs') : null,
      defaultLanguage === 'en' ? import(/* webpackChunkName: "cldr-en" */ './cldr/en') : null,
      defaultLanguage === 'ru' ? import(/* webpackChunkName: "cldr-ru" */ './cldr/ru') : null,
      defaultLanguage === 'uk' ? import(/* webpackChunkName: "cldr-uk" */ './cldr/uk') : null,
      defaultLanguage === 'fr' ? import(/* webpackChunkName: "cldr-fr" */ './cldr/fr') : null,
      defaultLanguage === 'es' ? import(/* webpackChunkName: "cldr-es" */ './cldr/es') : null,
    ]))
      .then(cldrs => {
        Globalize.load(flatten(cldrs.map(i => i.default)));
        Promise.resolve(messages)
          .then(messagesData => {
            let normalizedMessages = normalizeMessages(messagesData);
            Globalize.loadMessages(normalizedMessages);
            Globalize.locale(defaultLanguage);
          });
      });
  }

  return initializePromise;
};

export default initializeGlobalize;



// WEBPACK FOOTER //
// ./src/application/globalize/initializeGlobalize.js